import {
  SubmissionRequestSchema,
  type Submission,
  type SubmissionKind,
  type SubmissionRequest,
} from '../../domain/entities/submission.entity';

export interface SubmissionDatasource {
  submit(kind: SubmissionKind, body: SubmissionRequest): Promise<void>;
  /** O envio desta pessoa, ou `null` se ela ainda não enviou. */
  getMine(
    kind: SubmissionKind,
    exam: string,
    edition: number,
  ): Promise<Submission | null>;
}

export class SubmissionRepositoryImpl {
  private readonly datasource: SubmissionDatasource;

  constructor(datasource: SubmissionDatasource) {
    this.datasource = datasource;
  }

  /** Valida antes de enviar: envio vazio não é envio. */
  submit(kind: SubmissionKind, body: SubmissionRequest) {
    return this.datasource.submit(kind, SubmissionRequestSchema.parse(body));
  }

  getMine(kind: SubmissionKind, exam: string, edition: number) {
    return this.datasource.getMine(kind, exam, edition);
  }
}
